import React from 'react';
import { PhoneCall } from 'lucide-react';
import { Button } from './ui/Button';
export const UrgencyBar = () => {
  return <div className="bg-[#F5F5F5] border-y border-gray-200 py-6" data-id="element-253">
      <div className="container mx-auto px-4 md:px-6" data-id="element-254">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left" data-id="element-255">
          <div data-id="element-256">
            <h3 className="text-lg font-bold mb-1" data-id="element-257">
              Потрібна термінова допомога?
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-258">
              Лікар приїде за 30–60 хвилин у будь-яку точку міста
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-259">
            <a href="tel:+380000000000" className="flex items-center gap-2 text-xl font-bold hover:opacity-70 transition-opacity" data-id="element-260">
              <PhoneCall className="w-5 h-5" strokeWidth={2} data-id="element-261" />0 800 00 00 00
            </a>
            <Button data-id="element-262">Викликати зараз</Button>
          </div>
        </div>
      </div>
    </div>;
};